<template>
 <div id="instance-build">
  <section class="pb-8">
   <vs-row class="justify-center items-center">
    <div class="flex mt-3">
     <div v-for="(page, index) in pages" :key="index">
      <vs-chip :color="page.active ? 'primary' : ''">
       <b class="m-3">{{page.name}}</b>
      </vs-chip>

      <feather-icon
       class="mt-3 m-1"
       icon="ArrowRightIcon"
       v-if="pages.length -1 !== index"
       svgClasses="w-5 h-5 hover:text-primary stroke-current"
      />
     </div>
    </div>

    <div class="m-5 container-width">
     <phone-number-stage  v-if="actualIndexPage === 0"></phone-number-stage>
     <account-meta-stage  v-if="actualIndexPage === 1"></account-meta-stage>
     <business-data-stage v-if="actualIndexPage === 2"></business-data-stage>
     <authorize-stage     v-if="actualIndexPage === 3"></authorize-stage>
     <cloud-stage         v-if="actualIndexPage === 4"></cloud-stage>
    </div>

    <div class="flex mt-2 container-width">
     <div class="flex justify-start align-start container-width">
      <vs-button type="filled" @click.prevent="pageControl('previous')" :disabled="actualIndexPage === 0">
       <span>Voltar</span>
      </vs-button>
     </div>

     <div class="flex justify-end align-end container-width">
      <vs-checkbox v-if="!openPopUp" v-model="openPopUp">Abrir Popup</vs-checkbox>

      <connect-button color="primary" :instance-id="instanceId" @window-open="disablePopUp" v-if="openPopUp && (actualIndexPage === 2 || actualIndexPage === 3)">
       <span>{{ actualIndexPage === 2 ? 'Cadastrar' : 'Vincular' }}</span>
      </connect-button>

      <vs-button v-else color="primary" type="filled" @click.prevent="pageControl('next')">
       <span>{{ actualIndexPage === 4 ? 'Concluir' : 'Continuar'}}</span>
      </vs-button>
     </div>
    </div>
   </vs-row>
  </section>
 </div>
</template>

<script>

import ConnectButton from "@/components/integrated-onboarding-dialog/connect-button.vue";
import BusinessDataStage from "@/views/instances/build-stages/BusinessDataStage.vue";
import PhoneNumberStage from "@/views/instances/build-stages/PhoneNumberStage.vue";
import AccountMetaStage from "@/views/instances/build-stages/AccontMetaStage.vue";
import AuthorizeStage from "@/views/instances/build-stages/AuthorizeStage.vue";
import CloudStage from "@/views/instances/build-stages/CloudStage.vue";

import {formatRouteTenantPath, getCurrentTenant, instanceObject} from "@/utils";
import moduleInstance from "@/store/instance/moduleInstance";

export default {
 name: 'instance-build',
 components: {CloudStage, AuthorizeStage, BusinessDataStage, AccountMetaStage, PhoneNumberStage, ConnectButton},
 data() {
  return {
   openPopUp: true,
   pages: [
    { name: 'Número de Telefone', active: true  },
    { name: 'Conta do Facebook',  active: false },
    { name: 'Dados Comerciais',   active: false },
    { name: `Autorizar o ${process.env.VUE_APP_APP_TITLE || 'PedBot'}`, active: false },
    { name: 'Finalização',        active: false }
   ]
  }
 },
 computed:{
  actualIndexPage(){
   return this.pages.findIndex((page) => page.active);
  },
  activeUserPermission(){
   return this.$store.state.AppActiveUser.role
  },
  instanceId(){
   return Number(this.$route.params.id)
  },
  instanceObj() {
   return instanceObject(this.instanceId)
  }
 },
 methods: {
  disablePopUp(){
   this.openPopUp = false
  },
  async pageControl(method){
   this.openPopUp = true;
   const actualIndexPage = this.actualIndexPage;
   const increment = method === 'next' ? 1 : -1;
   const newIndexPage = actualIndexPage + increment;

   if (this.pages[newIndexPage]) {
    this.pages[newIndexPage]['active'] = true;
    this.pages[actualIndexPage]['active'] = false;
   } else if (newIndexPage > 4){
    await this.updateInstance();
   }
  },
  async updateInstance(){
   await this.$store.dispatch("instance/updateByIntegration", {id: this.instanceId})
    .then(() => {
     this.$router.push(formatRouteTenantPath('/instances/list/choose-instance'));
     this.$vs.notify({
      color: 'success',
      title: 'Conexão Ativada!',
      time: 7000
     });
    }).catch((error) => { console.log(error) })
  },
  async instanceFind(){
    if ( !this.instanceObj && Number.isInteger(this.instanceId)) {
      await this.$store.dispatch("instance/fetch", {id: this.instanceId})
    }

    if (
        !this.instanceObj ||
        !this.instanceObj['integration_id'] ||
        (this.instanceObj['activated'] && this.activeUserPermission.name !== 'root')
    ) {
      this.$router.push(formatRouteTenantPath('/instances/list/choose-instance'));

      if ( this.instanceObj && this.instanceObj['activated'] && this.activeUserPermission.name !== 'root' ){
        return this.$vs.notify({
          color: 'success',
          title: 'Conexão já ativada!',
          time: 7000
        });
      }

      this.$vs.notify({
        color: 'danger',
        title: 'Acesso não permitido!',
        time: 7000
      });
    }
  }
 },
 async mounted() {
  if (!moduleInstance.isRegistered) {
   this.$store.registerModule('instance', moduleInstance)
   moduleInstance.isRegistered = true
  }

  await this.instanceFind();

  this.$events.off('InstanceUpdated')
  this.$events.on('InstanceUpdated', (event) => {
   if (event.tenantName === getCurrentTenant() && this.instanceId === event.instance.id) {
    if ( event.isOnboarding ){
     this.$vs.notify({
      color: 'success',
      title: 'Prossiga com o preenchimento das informações para finalizar a ativação da conexão',
      time: 7000
     })
    }
   }
  })
 }
}
</script>

<style lang="scss">

#instance-build{
 .align-self-center {
  align-self: center !important;
 }

 .container-width {
  width: 70%;
 }
}

</style>